<script setup lang="ts">
import TravelUpdates from './components/TravelUpdates.vue'
</script>

<template>
  <div class="bg">
    <div class="cws">
      <TravelUpdates />
    </div>
  </div>
</template>
